import PropTypes from 'prop-types';
import React from 'react';
import { Prompt } from 'react-router-dom';

const UnsavedChangesPrompt = ({ dirty }) => (
  <Prompt
    when={dirty}
    message="You have unsaved changes, are you sure you want to leave?"
  />);

UnsavedChangesPrompt.propTypes = {
  dirty: PropTypes.bool.isRequired,
};

export default UnsavedChangesPrompt;



// WEBPACK FOOTER //
// ./src/components/UnsavedChangesPrompt/UnsavedChangesPrompt.jsx